// extracted by mini-css-extract-plugin
export default {"description":"BaechaListPanel_description__7Yor8","clickable":"BaechaListPanel_clickable__mUP2k"};